import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";

// Create a theme instance.
const theme = createTheme({
  components: {
    /** Only filled variant — do not style MuiInputBase globally or outlined fields inherit forced backgrounds. */
    MuiFilledInput: {
      styleOverrides: {
        root: {
          width: "100%",
          backgroundColor: "#fff",
          "&.Mui-disabled": {
            backgroundColor: "#e0e0e0",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: ["Inter", "sans-serif"].join(","),
    fontWeightBold: 400,
  },
  palette: {
    primary: {
      main: "#303F9F",
    },
    secondary: {
      main: "#FF5252",
    },
    error: {
      main: red.A400,
    },
  },
});

export default theme;
